import { AuthActions } from '../../actions/constant';
import tokenManagementService from '../../../services/tokenManagementService/tokenService';
import {
  therapistToken,
  therapistRefreshToken,
  therapistIdToken,
} from '../../../services/tokenManagementService/constant';
const {
  THERAPIST_LOGIN_SUCCESS,
  THERAPIST_LOGIN_FAILURE,
  THERAPIST_LOGOUT_SUCCESS,
  THERAPIST_LOGIN_RESET,
  THERAPIST_LOGOUT_RESET,
  THERAPIST_FACILITY_NOT_FOUND,
  TOKEN_FIRST_TIME,
} = AuthActions;
import { secretKey } from 'src/config';

const intialLoginstate: object = {
  isLoggedIn: false,
  response: null,
  facilityAssigned: false,
  tokenFirstTime: false,
};

export const therapistLoginReducer = (state = intialLoginstate, action: any) => {
  switch (action.type) {
    case THERAPIST_LOGIN_SUCCESS: {
      const expirationtime = action.payload.expires_in;
      const refreshTockenExpireTime = action.payload.refresh_expires_in;

      let date = new Date();
      date.setTime(date.getTime() + expirationtime * 1000);
      const expires = date.toUTCString();

      let date2 = new Date();
      date2.setTime(date2.getTime() + refreshTockenExpireTime * 1000);
      const refreshExpires = date2.toUTCString();

      tokenManagementService.setToken(therapistToken, action.payload.access_token, secretKey, {
        path: '/',
        expires: expires,
      });
      tokenManagementService.setToken(
        therapistRefreshToken,
        action.payload.refresh_token,
        secretKey,
        { path: '/', expires: refreshExpires }
      );
      tokenManagementService.setToken(therapistIdToken, action.payload.id_token, secretKey, {
        path: '/',
      });
      return {
        ...state,
        isLoggedIn: true,
        response: action.payload,
        facilityAssigned: true,
      };
    }

    case THERAPIST_LOGIN_FAILURE:
      return {
        ...state,
        isLoggedIn: false,
        response: action.payload,
        facilityAssigned: true,
      };

    case THERAPIST_LOGOUT_SUCCESS: {
      return {
        ...state,
        isLoggedIn: false,
        response: null,
        facilityAssigned: false,
      };
    }

    case THERAPIST_LOGIN_RESET: {
      return {
        ...state,
        isLoggedIn: false,
        response: null,
        facilityAssigned: false,
        tokenFirstTime: false,
      };
    }

    case THERAPIST_LOGOUT_RESET: {
      return {
        ...state,
        isLoggedIn: false,
        response: null,
        facilityAssigned: false,
        tokenFirstTime: false,
      };
    }

    case THERAPIST_FACILITY_NOT_FOUND: {
      const refreshTockenExpireTime = action.payload.refresh_expires_in;
      let date2 = new Date();
      date2.setTime(date2.getTime() + refreshTockenExpireTime * 1000);
      const refreshExpires = date2.toUTCString();

      tokenManagementService.setToken(
        therapistRefreshToken,
        action.payload.refresh_token,
        secretKey,
        { path: '/', expires: refreshExpires }
      );

      return {
        ...state,
        isLoggedIn: true,
        response: action.payload,
        facilityAssigned: true,
        tokenFirstTime: false,
      };
    }

    case TOKEN_FIRST_TIME: {
      return {
        ...state,
        tokenFirstTime: true,
      };
    }

    default:
      return state;
  }
};
